import React from 'react';
import { BadgeAlt as UIBadge, DataTableColumnHeader } from '@cargomatic/ui';
import ExternalLink from 'components/v2/ExternalLink';
import moment from 'moment';
import formatMoney from 'utils/formatters/Money';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { AccessorialRateStatusBadge } from 'components/v2/AccessorialRateStatusBadge';
import LegTypeBadge from 'components/v2/LegTypeBadge';
export function getAccessorialRatesColumns() {
    const showAutoApply = featureEnabled(CONFIGURED_FEATURES === null || CONFIGURED_FEATURES === void 0 ? void 0 : CONFIGURED_FEATURES.AUTO_APPLY_ACCESSORIAL);
    const columns = [
        {
            accessorKey: 'customerType',
            header: () => 'User',
            cell: ({ row }) => {
                const type = row.original.customerType;
                return type === 'carrier' ? (React.createElement(UIBadge, { variant: "outline", className: "bg-blue-50 text-blue-700 border-blue-200" }, "Carrier")) : (React.createElement(UIBadge, { variant: "outline", className: "bg-green-50 text-green-700 border-green-200" }, "Shipper"));
            },
            enableSorting: false,
            size: 80,
        },
        {
            accessorKey: 'name',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Customer" })),
            cell: ({ row }) => (React.createElement(ExternalLink, { dataTestId: `customer-${row.original.customer}`, title: row.original.name, href: `/users/${row.original.customer}` })),
            size: 180,
        },
        {
            accessorKey: 'market',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Market" })),
            cell: ({ row }) => React.createElement("span", null, row.original.market),
            size: 140,
        },
        {
            accessorKey: 'legType',
            header: () => 'Leg Type',
            cell: ({ row }) => row.original.legType ? (React.createElement(LegTypeBadge, { legType: row.original.legType })) : (React.createElement("span", { className: "text-muted-foreground" }, '\u2014')),
            enableSorting: false,
            size: 160,
        },
        {
            accessorKey: 'accessorialtype',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Type" })),
            cell: ({ row }) => React.createElement("span", null, row.original.accessorialtype),
            size: 120,
        },
        {
            accessorKey: 'accesscode',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Code" })),
            cell: ({ row }) => React.createElement("span", null, row.original.accesscode),
            size: 70,
        },
        {
            accessorKey: 'ratetype',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Rate Type" })),
            cell: ({ row }) => React.createElement("span", null, row.original.ratetype),
            size: 80,
        },
        {
            accessorKey: 'rate',
            header: ({ column }) => (React.createElement("div", { className: "text-right" },
                React.createElement(DataTableColumnHeader, { column: column, title: "Rate" }))),
            cell: ({ row }) => (React.createElement("div", { className: "text-right" }, row.original.ratetype === '%'
                ? `${row.original.rate}%`
                : formatMoney(row.original.rate))),
            size: 80,
        },
        {
            accessorKey: 'units',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Unit" })),
            cell: ({ row }) => React.createElement("span", null, row.original.units),
            size: 80,
        },
        {
            id: 'validity',
            header: () => 'Validity',
            cell: ({ row }) => (React.createElement("span", null,
                moment(row.original.effectiveStart).format('L'),
                ' \u2013 ',
                moment(row.original.effectiveEnd).format('L'))),
            enableSorting: false,
            size: 180,
        },
    ];
    if (showAutoApply) {
        columns.push({
            accessorKey: 'autoApply',
            header: () => 'Auto Apply',
            cell: ({ row }) => React.createElement("span", null, row.original.autoApply ? 'Yes' : 'No'),
            enableSorting: false,
            size: 110,
        });
    }
    columns.push({
        accessorKey: 'status',
        header: () => 'Status',
        cell: ({ row }) => (React.createElement(AccessorialRateStatusBadge, { status: row.original.status })),
        enableSorting: false,
        size: 90,
    }, {
        accessorKey: 'updatedAt',
        header: () => 'Updated',
        cell: ({ row }) => (React.createElement("span", null, moment(row.original.updatedAt).fromNow())),
        enableSorting: false,
        size: 100,
    }, {
        accessorKey: 'quoteId',
        header: () => 'Quote ID',
        cell: ({ row }) => React.createElement("span", null, row.original.quoteId || '\u2014'),
        enableSorting: false,
        size: 110,
    }, {
        accessorKey: 'notes',
        header: () => 'Notes',
        cell: ({ row }) => (React.createElement("span", { className: "truncate max-w-[120px] block" }, row.original.notes || '\u2014')),
        enableSorting: false,
        size: 100,
    });
    return columns;
}
